// Локсодромия по средней широте — ОДНА на всех, кто рисует линию от точки.
//
// Была приватной в `vesselForecast.ts`. Второй копии тут быть не должно:
// формула короткая и оттого особенно легко копируется, а разъехавшись (знак
// синуса, деление на косинус не той широты), копии дают линии, которые обе
// выглядят правдоподобно и уходят в разные стороны. Ровно так уже расходились
// палитры карты и пороги скорости судна.

/** Точка, удалённая от (lat, lon) на `milesRun` морских миль по курсу `courseDeg`.
 *
 *  На десятках миль большой круг от локсодромии не отличить, а постоянным
 *  курсом объект и идёт. Возвращает `[lon, lat]` — порядок GeoJSON. */
export function runTo(
  lat: number,
  lon: number,
  courseDeg: number,
  milesRun: number,
): [number, number] {
  const rad = (courseDeg * Math.PI) / 180
  const dLat = (milesRun * Math.cos(rad)) / 60
  const midLat = ((lat + (lat + dLat)) / 2) * (Math.PI / 180)
  const dLon = (milesRun * Math.sin(rad)) / (60 * Math.cos(midLat))
  return [lon + dLon, lat + dLat]
}

/** Метры в морских милях — единица, в которой считает `runTo`. */
export const M_PER_NM = 1852
